var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoCitec = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 91,
  height: 24,
  viewBox: "0 0 91 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  color: "#ECF0FB",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5115 1.95953V3.9358C17.6762 2.42847 14.8966 1.67481 12.1729 1.67481C9.27063 1.67481 6.84274 2.66295 4.88927 4.63922C2.93579 6.61549 1.95906 9.08304 1.95906 12.0419C1.95906 15.0342 2.94138 17.4962 4.90601 19.4278C6.87065 21.3594 9.37668 22.3252 12.4241 22.3252C14.9692 22.3252 17.7431 21.5269 20.7459 19.9302V21.806C17.9775 23.2687 15.2148 24 12.4576 24C8.89668 24 5.9274 22.8611 3.54974 20.5834C1.18325 18.2945 0 15.4473 0 12.0419C0 8.6141 1.21115 5.75017 3.63346 3.4501C6.05577 1.15004 8.94133 0 12.2901 0C14.9245 0 17.665 0.653175 20.5115 1.95953Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6137 8.2903V23.6985H24.956V8.2903H26.6137Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5604 0.301465V1.80879H40.7865V23.6985H38.9614V1.80879H30.1875V0.301465H49.5604Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2449 0.301465V1.80879H55.2943V11.171H65.9603V12.695H55.2943V22.1912H66.5128V23.6985H53.4859V0.301465H66.2449Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M90.7656 1.95953V3.9358C87.9303 2.42847 85.1507 1.67481 82.427 1.67481C79.5247 1.67481 77.0968 2.66295 75.1434 4.63922C73.1899 6.61549 72.2132 9.08304 72.2132 12.0419C72.2132 15.0342 73.1955 17.4962 75.1601 19.4278C77.1247 21.3594 79.6308 22.3252 82.6782 22.3252C85.2233 22.3252 87.9972 21.5269 91 19.9302V21.806C88.2316 23.2687 85.4689 24 82.7117 24C79.1508 24 76.1815 22.8611 73.8038 20.5834C71.4373 18.2945 70.2541 15.4473 70.2541 12.0419C70.2541 8.6141 71.4652 5.75017 73.8876 3.4501C76.3099 1.15004 79.1954 0 82.5442 0C85.1786 0 87.9191 0.653175 90.7656 1.95953Z",
  fill: "currentColor"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2.40072,
  height: 2.40072,
  transform: "matrix(0.707022 -0.707191 0.707022 0.707191 24.0444 2.07227)",
  fill: "#3D58E5"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoCitec);
export { ForwardRef as ReactComponent };